import { Injectable } from '@angular/core';

const NO_VERSION_UP = "0";
const MODE_1 = "1";
const MODE_2 = "2";

@Injectable()
export class VersionupService {

  code: string = NO_VERSION_UP;

  constructor(
  ) {
  }

  /**
   * バージョンアップコードを更新する
   * @param code: string
   * @return void
   */
  setCode(code: string): void {
    this.code = code;
  }

  /**
   * モード1
   * 通知のみ: アップデートの通知のみ
   * @return boolean
   */
  isMode1(): boolean {
    return this.code === MODE_1;
  }

  /**
   * モード2
   * 強制アップデート: バージョンアップページに強制遷移させる
   * @return boolean
   */
  isMode2(): boolean {
    return this.code === MODE_2;
  }

}



// WEBPACK FOOTER //
// ./src/providers/versionup.service.ts